import { createSlice } from "@reduxjs/toolkit"
import { API_PRINT_DEFAULT } from "../constants/initStateItems"
import actionTypes from "../action/actionTypes"
import requestStatus from "../../lib/constants/requestStatus"


const apiPrintReducerResult = createSlice({
    name: 'apiPrint',
    initialState: API_PRINT_DEFAULT,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addMatcher(
            (action) => action.type === actionTypes.MATRIX_RESULTS_PRINT_REQUEST,
            (state, action) => ({
                ... API_PRINT_DEFAULT,
                status: requestStatus.REQUEST_PENDING,
            })
          )
          .addMatcher(
            (action) => action.type === actionTypes.MATRIX_RESULTS_PRINT_SUCCESS,
            (state, action) => ({
                ... API_PRINT_DEFAULT,
                status: requestStatus.REQUEST_SUCCESS,
            })
          )
          .addMatcher(
            (action) => action.type === actionTypes.MATRIX_RESULTS_PRINT_ERROR,
            (state, action) => ({
                status: requestStatus.REQUEST_ERROR,
                error: action.payload.error
            })
          )
      },
})

export default apiPrintReducerResult.reducer